import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
export function AgitationSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="py-24 px-4" style={{
    background: 'var(--color-surface)'
  }} data-id="element-1">
      <div className="max-w-2xl mx-auto" data-id="element-2">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.7
      }} data-id="element-3">
          <p className="text-sm font-semibold tracking-widest uppercase mb-6" style={{
          color: 'var(--color-accent)'
        }} data-id="element-4">
            El patrón que nadie quiere ver
          </p>

          <h2 className="text-3xl md:text-4xl font-black mb-10 leading-tight" style={{
          fontFamily: 'Playfair Display, serif',
          color: 'var(--color-text)'
        }} data-id="element-5">
            Permíteme preguntarte algo que quizás nadie más te va a preguntar:
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} animate={isInView ? {
        opacity: 1
      } : {}} transition={{
        delay: 0.3,
        duration: 0.7
      }} className="space-y-4 mb-12" data-id="element-6">
          <p className="text-xl leading-relaxed" style={{
          color: 'var(--color-text-muted)'
        }} data-id="element-7">
            ¿Cuántos libros llevas leídos este año?
          </p>
          <p className="text-xl leading-relaxed" style={{
          color: 'var(--color-text-muted)'
        }} data-id="element-8">
            ¿Cuántos cursos comprados que nunca terminaste?
          </p>
          <p className="text-xl leading-relaxed" style={{
          color: 'var(--color-text-muted)'
        }} data-id="element-9">
            ¿Cuántas mañanas empezaste con intención absoluta… y terminaste
            exactamente igual que la anterior?
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        delay: 0.5,
        duration: 0.7
      }} data-id="element-10">
          <p className="text-lg font-medium mb-4" style={{
          color: 'var(--color-text-muted)'
        }} data-id="element-11">
            Esto tiene un nombre.
          </p>

          {/* Mechanism name highlight */}
          <div className="py-8 px-8 my-8 text-center rounded-sm" style={{
          background: '#0f0f0f',
          border: '1px solid var(--color-accent)'
        }} data-id="element-12">
            <p className="text-2xl md:text-3xl font-black" style={{
            fontFamily: 'Playfair Display, serif',
            color: 'var(--color-accent)'
          }} data-id="element-13">
              El Techo de Programación Interna™
            </p>
          </div>

          <p className="text-lg leading-relaxed mb-6" style={{
          color: 'var(--color-text-muted)'
        }} data-id="element-14">
            No es un concepto espiritual vago. Es una arquitectura real —
            instalada en tu mente antes de que tuvieras la capacidad de
            cuestionarla.
          </p>

          <p className="text-lg leading-relaxed mb-6" style={{
          color: 'var(--color-text-muted)'
        }} data-id="element-15">
            Antes de los 10 años, tu cerebro absorbió creencias sobre el dinero,
            el merecimiento, el esfuerzo, la abundancia y el peligro. Esas
            creencias se convirtieron en tu sistema operativo.
          </p>

          <p className="text-xl font-bold mb-8" style={{
          color: 'var(--color-text)'
        }} data-id="element-16">
            Y ese sistema operativo define, silenciosamente:
          </p>

          <div className="space-y-3 mb-10" data-id="element-17">
            <div className="flex items-start gap-3" data-id="element-18">
              <span style={{
              color: 'var(--color-accent)'
            }} className="text-xl mt-0.5" data-id="element-19">
                —
              </span>
              <p className="text-lg" style={{
              color: 'var(--color-text-muted)'
            }} data-id="element-20">
                Cuánto puedes ganar.
              </p>
            </div>
            <div className="flex items-start gap-3" data-id="element-21">
              <span style={{
              color: 'var(--color-accent)'
            }} className="text-xl mt-0.5" data-id="element-22">
                —
              </span>
              <p className="text-lg" style={{
              color: 'var(--color-text-muted)'
            }} data-id="element-23">
                Qué decisiones "te salen naturales."
              </p>
            </div>
            <div className="flex items-start gap-3" data-id="element-24">
              <span style={{
              color: 'var(--color-accent)'
            }} className="text-xl mt-0.5" data-id="element-25">
                —
              </span>
              <p className="text-lg" style={{
              color: 'var(--color-text-muted)'
            }} data-id="element-26">
                Cuánto éxito te permites tener antes de sabotearlo.
              </p>
            </div>
          </div>

          <div className="py-6 px-8 rounded-sm" style={{
          background: '#0f0f0f',
          borderLeft: '4px solid var(--color-accent)'
        }} data-id="element-27">
            <p className="text-lg font-semibold mb-2" style={{
            color: 'var(--color-text)'
          }} data-id="element-28">
              El problema no es lo que sabes.
            </p>
            <p className="text-xl font-black" style={{
            fontFamily: 'Playfair Display, serif',
            color: 'var(--color-accent)'
          }} data-id="element-29">
              El problema es lo que tu subconsciente sigue creyendo.
            </p>
          </div>

          <div className="mt-10 space-y-3" data-id="element-30">
            <p className="text-lg" style={{
            color: 'var(--color-text-muted)'
          }} data-id="element-31">
              Y los libros de motivación…{' '}
              <strong style={{
              color: 'var(--color-text)'
            }} data-id="element-32">
                no tocan eso.
              </strong>
            </p>
            <p className="text-lg" style={{
            color: 'var(--color-text-muted)'
          }} data-id="element-33">
              Los videos de YouTube…{' '}
              <strong style={{
              color: 'var(--color-text)'
            }} data-id="element-34">
                no tocan eso.
              </strong>
            </p>
            <p className="text-lg" style={{
            color: 'var(--color-text-muted)'
          }} data-id="element-35">
              Las frases bonitas en Instagram…{' '}
              <strong style={{
              color: 'var(--color-text)'
            }} data-id="element-36">
                definitivamente no tocan eso.
              </strong>
            </p>
          </div>

          <p className="text-xl font-bold mt-10" style={{
          color: 'var(--color-text)'
        }} data-id="element-37">
            Por eso llevas años consumiendo y sintiéndote igual.
          </p>
        </motion.div>
      </div>
    </section>;
}